import { ArticleForLink } from '@pt/models';

export function getRouterLinkForArticle(newsSegment: string, article: ArticleForLink): string[] {
  return [
    newsSegment,
    article.category.slug,
    article.subcategory?.slug ?? 'article',
    article.slug,
  ];
}
